export namespace DokumentModels {

    export interface Dokument {
        documentID: string;
        objectID: string;
        adress?: number;
        documentName: string;
        description: string;
        keywords: string;
        createdBy: string;
        created: Date;
        modifiedBy: string;
        modified: Date;
        private: number;
        contact?: number;
        mainDocument: number;
        AdressID: string;
        ContactID: string;
        documentPath: string;
        sA_TransDocType?: number;
    }

    export interface DokumentInfo {
        isS3Document?: boolean;
        objectID: string;
        documentID: string;
        fileName: string;
        description: string;
        dokumentTyp: DokumentTyp;
        dokumentQuelle: DokumentSource;
        userName?: string;
        lastModified: Date;
        fromLocalStorage?: boolean;
    }

    export class DocumentInfoWithFile implements DokumentInfo {
        objectID: string;
        documentID: string;
        fileName: string;
        description: string;
        dokumentTyp: DokumentTyp;
        dokumentQuelle: DokumentSource; // garbage info i think
        userName?: string | undefined;
        file: Blob;
        lastModified: Date;
        fromLocalStorage = false;
        isS3Document = false;

        constructor(docInfo: DokumentInfo, file: Blob) {
            this.objectID = docInfo.objectID;
            this.documentID = docInfo.documentID;
            this.fileName = docInfo.fileName;
            this.description = docInfo.description;
            this.dokumentTyp = docInfo.dokumentTyp;
            this.dokumentQuelle = docInfo.dokumentQuelle;
            this.userName = docInfo.userName;
            this.lastModified = docInfo.lastModified || new Date();
            this.file = file;
            this.fromLocalStorage = !!docInfo.fromLocalStorage;
            this.isS3Document = !!docInfo.isS3Document;
        }

        // tslint:disable-next-line:variable-name
        private _synced = false;

        get synced(): boolean {
            return this._synced;
        }

        set synced(value: boolean) {
            this._synced = value;
        }
    }

    export interface DocumentDownloadError {
        value: string;
        code: string;
        fileName: string; // TODO fileName will be documentID in some cases
    }

    export interface DokumentBild {
        objectID: string;
        documentID: string;
        fileName: string;
        binary: Blob;
        doEdit: boolean;
        lastModified?: Date;
    }

    export interface NotizblattDokument {
        documentID: string;
        description: string;
        createdBy: string;
        createdDate: Date;
        objectID: string;
        fileName: string;
        binary: Blob;
        lastModified: Date;
    }

    export interface SwissAppFileReport {
        mandatorID: string;
        iD_SwissAppReport: number;
        pdfFileTemplate: Blob;
    }

    // Der DokumentTyp entspricht dem Feld SA_TransDocType in der Datenbank
    export enum DokumentTyp {
        Rapport = '1',
        Checkliste = '2',
        Dokument = '3',
        Foto = '9',
        Notizblatt = '10',
        ObjektRapport = '11',
        ObjektReport = '12'
    }

    export enum DokumentSource {
        FromWebService = '1',
        SA_DBDokumente = '2',
        SA_DBRapporte = '3',
        SA_DBChecklisten = '4',
        SA_DBBilder = '5',
        OfflineObjektNavi = '6',
        ObjektRapport = '7',
        ObjektReport = '8',
        ObjektNavi = '9',
    }
}
